<template>
  <div class="landing-page-container">
    <h3>Loading...</h3>
    <loader-static :loading="true" :size="'20px'" :dark="true" class="centered"></loader-static>
    <p>If you are <n></n>ot redirected to the collections, please be sure to disable any ad-blockers.</p>
  </div>
</template>

<script>
export default {
  name: "HolidayLanding",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.landing-page-container {
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 40px;
  text-align: center;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h3 {
    margin-bottom: 5px;
  }
}
</style>
